export default function ConfigPage() {
  return (
    <div>
    </div>
  )
}